<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a routerLink="/admin/dashboard/">Home</a></li>
      <li class="breadcrumb-item" *ngIf="user.role === 'ACCOUNT_OWNER'"><a routerLink="/admin/storeIntegrations/">Channels</a></li>
      <li class="breadcrumb-item active" aria-current="page">Manage Channel</li>
    </ol>
  </nav>

  <div class="row">
    <div class="col">
      <div class="inner-box p-4">
        <form>
          <div class="row">
            <div class="col-md-3">
              <div class="form-group">
                <label class="control-label">Channel Name</label>
                <input type="text" id="channelNameShopclues" class="form-control" (blur)="typeChannelName()"
                       [ngClass]="{'is-invalid':statusText22}" [(ngModel)]="storeManage.connectionName"
                       [ngModelOptions]="{standalone: true}" required>
                <div id="statusText22" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!statusText22">{{statusText22}}</div>
              </div>
              <div class="form-group">
                <label class="control-label">Host Name</label>
                <div class="row">
                  <div class="col-4 pr-1">
                    <input type="text"  class="form-control "  [(ngModel)]="hostNamePrefix" [ngModelOptions]="{standalone: true}" disabled>
                  </div>
                  <div class="col-8 pl-1">
                    <input type="text" id="storeId" class="form-control" (blur)="typeHostName()"
                           [ngClass]="{'is-invalid':statusText2}" [(ngModel)]="storeManage.hostName"
                           [ngModelOptions]="{standalone: true}" required>
                    <div id="statusText2" class="invalid-feedback d-block shift-invalid-login"
                         [hidden]="!statusText2">{{statusText2}}</div>
                  </div>
                </div>

              </div>
              <div class="form-group mb-lg-0">
                <label class="control-label" for="version">Version</label>
                <input type="text" id="version" class="form-control" (blur)="typeVersion()" [ngClass]="{'is-invalid':statusText6}" [(ngModel)]="storeManage.version" [ngModelOptions]="{standalone: true}" placeholder="Version" required>
                <div id="statusText6"class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText6">{{statusText6}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <div class="form-group">
                <label class="control-label">API Key</label>
                <input type="text" id="apiKey" class="form-control" (blur)="typeApiKey()" [ngClass]="{'is-invalid':statusText11}" [(ngModel)]="storeManage.apiKey" [ngModelOptions]="{standalone: true}" placeholder="API Key" required>
                <div id="statusText11"class="invalid-feedback d-block shift-invalid-login" [hidden]="!statusText11">{{statusText11}}</div>
              </div>
              <div class="form-group">
                <label class="control-label">Password</label>
                <input type="password" id="password" class="form-control" (blur)="selectPassword()"
                       [ngClass]="{'is-invalid':statusText1}" [(ngModel)]="storeManage.clientSecret"
                       [ngModelOptions]="{standalone: true}" required>
                <div id="statusText1" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!statusText1">{{statusText1}}</div>
              </div>
            </div>
            <div class="col-md-3">
              <label>&nbsp;</label>
              <div class="upload-box" *ngIf="!imageUrl">
                <input type="file"  (change)="loadImage($event)">
                <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                </svg>
                <div>upload logo</div>
              </div>
              <div class="upload-box mt-2" *ngIf="imageUrl">
                <img class="shift-uploaded-img shift-image" src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}"  width="250" height="250" />
                <div class="invalid-feedback d-block shift-invalid-text" [hidden]="!errorMessage">{{errorMessage}}</div>
                <img class="d-lg-none d-sm-none d-xs-none d-md-block shift-uploaded-img" src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}" width="150" height="150" />
                <img class="d-lg-none d-md-none d-xs-none d-sm-block shift-uploaded-img" src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}" width="100" height="100" />
                <img class="d-lg-none d-md-none d-sm-none d-xs-block shift-uploaded-img" src="{{imageUrl !=null ? imageUrl : 'https://shift-images.s3.ap-south-1.amazonaws.com/Img-20-02-2020-19-51-56default-product.png'}}" width="50" height="50" />

                <div class="overly">
                  <button class="btn">
                    <input type="file" class="plus-upload-btn" (change)="loadImage($event)">
                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>Upload</button>
                  <button class="btn" (click)="ignoreImage()">
<!--                    <input type="file" (change)="ignoreImage()">-->
                    <svg width="2em" height="2em" viewBox="0 0 16 16" class="bi bi-plus" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                      <path fill-rule="evenodd" d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                    </svg>Remove</button>
                </div>
              </div>
            </div>
            <div class="col-md-3 align-self-end">
              <div class="instr-box">
                <span>Shopclues Market Place Instructions </span><svg xmlns="http://www.w3.org/2000/svg" width="17.14" height="17.14" viewBox="0 0 17.14 17.14">
                <path id="Icon_awesome-question-circle" data-name="Icon awesome-question-circle" d="M17.7,9.132A8.57,8.57,0,1,1,9.132.563,8.569,8.569,0,0,1,17.7,9.132ZM9.362,3.4A4.476,4.476,0,0,0,5.335,5.6a.415.415,0,0,0,.094.562l1.2.909A.415.415,0,0,0,7.2,7c.617-.783,1.041-1.237,1.98-1.237.706,0,1.579.454,1.579,1.139,0,.518-.427.783-1.124,1.174C8.826,8.529,7.75,9.1,7.75,10.515v.138a.415.415,0,0,0,.415.415H10.1a.415.415,0,0,0,.415-.415v-.046c0-.984,2.875-1.024,2.875-3.686C13.389,4.916,11.31,3.4,9.362,3.4Zm-.23,8.57a1.59,1.59,0,1,0,1.59,1.59A1.591,1.591,0,0,0,9.132,11.966Z" transform="translate(-0.563 -0.563)" fill="#c1c1c1"/>
              </svg>
              </div>
              <a href="https://signin.sandbox.ebay.com/ws/eBayISAPI.dll?SignIn&runame=Shift-Shift-Shift-SBX-nmktlh&SessID={{store.apiKey}}" class="btn btn-orange btn-block">Test Connection & Save</a>
<!--              <button class="btn btn-orange btn-block" (click)="verifyShopify()">Test Connection & Save   </button>-->
            </div>
          </div>
        </form>

      </div>
    </div>
  </div>
  <div class="row mt-4">
    <div class="col">
      <ul class="list-inline tab-list">
        <li class="list-inline-item"><a class="list-inline-item" (click)=" tabChange('ORDERS');" [ngClass]="{'active': tabClicked === 'ORDERS'}">Orders</a></li>
        <li class="list-inline-item"><a class="nav-link PRODUCTS" (click)=" tabChange('PRODUCTS');" [ngClass]="{'active': tabClicked === 'PRODUCTS'}">Products</a></li>
      </ul>
      <!--
             <div class="inner-box pb-0 pt-4 h-auto disabled">
      -->
      <div class="inner-box pb-0 pt-4 h-auto" [hidden]="tabClicked != 'ORDERS'">
        <div class="row">
          <div class="col-11">
            <div class="row no-gutters">
              <div class="col-md-3">
                <div id="importOrders" class="grid-box"  [ngClass]="{'active':['manualImport','updateOrders','scheduleOrders'].indexOf(tabActive) == -1}">
                  <div class="row align-items-center justify-content-between">
                    <div class="col-auto">
                      <h2 class="color-3 text-capitalize">Sync Configuration</h2>
                    </div>
                    <div class="col-auto"><div class="toggle-2">
                      <input type="checkbox" id="importOrdersCB" name="import" [(ngModel)]="importOrders" checked="" (change)="submitAll()" class="custom-control-input checkbox">
                      <label for="importOrdersCB" class="toggle">
                        <span>ON</span><span>OFF</span>
                      </label>
                    </div> </div>
                  </div>
                  <div class="c-height">
                    Please mention order statuses from your channel that you want to pull into the Processing state in Shift
                  </div>
                  <button class="btn btn-cancel-prime" [disabled]="!importOrders" (click)="openDetailSection('importOrders')">Manage</button>
                </div>
              </div>
              <div class="col-md-3">
                <div id="scheduleOrders" class="grid-box" [ngClass]="{'active':tabActive == 'scheduleOrders'}">
                  <div class="row align-items-center justify-content-between">
                    <div class="col-auto">
                      <h2 class="color-3 text-capitalize">Schedule Orders Sync</h2>
                    </div>
                    <div class="col-auto"><div class="toggle-2">
                      <input type="checkbox" id="scheduleOrdersCB" name="Schedule" (change)="submitAll()" [(ngModel)]="scheduleOrders" checked="" class="custom-control-input checkbox">
                      <label for="scheduleOrdersCB" class="toggle">
                        <span>ON</span><span>OFF</span>
                      </label>
                    </div> </div>
                  </div>
                  <div class="c-height">
                    Please mention order statuses from your channel that you want to pull into the Processing state in Shift
                  </div>
                  <button class="btn btn-cancel-prime" [disabled]="!scheduleOrders" (click)="openDetailSection('scheduleOrders')">Manage</button>
                </div>
              </div>
              <div class="col-md-3">
                <div id="updateOrders" class="grid-box" [ngClass]="{'active':tabActive == 'updateOrders'}">
                  <div class="row align-items-center justify-content-between">
                    <div class="col-auto">
                      <h2 class="color-3 text-capitalize">Update Orders</h2>
                    </div>
                    <div class="col-auto"><div class="toggle-2">
                      <input type="checkbox" id="updateOrdersCB" name="update" [(ngModel)]="updateOrders" checked="" (change)="submitAll()" class="custom-control-input checkbox">
                      <label for="updateOrdersCB" class="toggle">
                        <span>ON</span><span>OFF</span>
                      </label>
                    </div> </div>
                  </div>
                  <div class="c-height">
                    Please mention order statuses from your channel that you want to pull into the Processing state in Shift
                  </div>
                  <button class="btn btn-cancel-prime" [disabled]="!updateOrders" (click)="openDetailSection('updateOrders')">Manage</button>
                </div>
              </div>
              <div class="col-md-3">
                <div id="manualImport" class="grid-box" [ngClass]="{'active':tabActive == 'manualImport'}">
                  <div class="row align-items-center justify-content-between">
                    <div class="col-auto">
                      <h2 class="color-3 text-capitalize">Manual Orders Sync</h2>
                    </div>
                    <div class="col-auto"><div class="toggle-2">
                      <input type="checkbox" id="manualImports" name="Manual" checked="" [(ngModel)]="manualImportsOrders" (change)="submitAll()" class="custom-control-input checkbox">
                      <label for="manualImports" class="toggle">
                        <span>ON</span><span>OFF</span>
                      </label>
                    </div> </div>
                  </div>
                  <div class="c-height">
                    Please mention order statuses from your channel that you want to pull into the Processing state in Shift
                  </div>
                  <button class="btn btn-cancel-prime" [disabled]="!manualImportsOrders" (click)="openDetailSection('manualImport')">Manage</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="grid-main">
          <!-- Import Orders -->
          <div *ngIf="['manualImport','updateOrders','scheduleOrders'].indexOf(tabActive) == -1 && importOrders">
            <div class="row-box " >
              <div class="row border-bottom">
                <div class="col-md-3"><b>Provider Status</b></div>
                <div class="col-md-5">
                  <b>Shift Status</b>
                </div>
              </div>
              <div *ngFor="let p of importsdropdownList;let i = index;">
              <div class="row border-bottom align-items-center" >
                <div class="col-md-3">
                  {{p.label}}
                </div>
                <div class="col-md-4">
                  <select id="addressType" class="form-control" [(ngModel)]="selectedSyncStatus[i]"
                          [ngModelOptions]="{standalone: true}" (change)="submitSyncStatus(p.config,selectedSyncStatus[i])" required>
                    <option *ngFor="let status of orderStatuses" [ngValue]="status.config">
                      {{status.label}}</option>
                    <option value=""> </option>
                  </select>
                </div>
              </div>
              </div>

            </div>
            <div class="row-box " >
              <div class="row border-bottom mt-5">
                <div class="col-md-3"><b>Fulfillment Status</b></div>
                <div class="col-md-5">
                  <b>Shift Status</b>
                </div>
              </div>
              <div *ngFor="let p of importsFulFillmentStatusList;let i = index;">
                <div class="row border-bottom align-items-center" >
                  <div class="col-md-3">
                    {{p.label}}
                  </div>
                  <div class="col-md-4">
                    <select id="addressType" class="form-control" [(ngModel)]="selectedFulfillStatus[i]"
                            [ngModelOptions]="{standalone: true}" (change)="submitSyncFulfillStatus(p.config,selectedFulfillStatus[i])" required>
                      <option *ngFor="let status of orderStatuses" [ngValue]="status.config">
                        {{status.label}}</option>
                      <option value=""> </option>
                    </select>
                  </div>
                </div>
              </div>

            </div>
          </div>

          <!-- End Import Orders -->

          <!-- Manual -->
          <div  [hidden]="!(tabActive =='manualImport' && manualImportsOrders)">
            <div class="row">
              <div class="col-md-6"><div class="form-radio mr-4">
                <input type="radio" (change)="selectDateType()" name="periodicType" id="dateRangeOrders"
                       [(ngModel)]="selectPeriodicType" [ngModelOptions]="{standalone: true}" required
                       value="Date Range">
                <label for="dateRangeOrders">Date Range</label>
              </div> <div class="form-radio mr-4">
                <input type="radio" (change)="selectDateType()" name="periodicType" id="lastDaysOrders"
                       [(ngModel)]="selectPeriodicType" [ngModelOptions]="{standalone: true}" required
                       value="Last Days">
                <label for="lastDaysOrders">No. of Days</label>
              </div>
                <div class="form-radio">
                  <input type="radio" (change)="selectDateType()" name="periodicType" id="orderNumber"
                         [(ngModel)]="selectPeriodicType" [ngModelOptions]="{standalone: true}" required
                         value="Order Number">
                  <label for="orderNumber">Order Number</label>
                </div>
              </div>
            </div>
            <!-- Date Range -->
            <div class="row my-3">
              <div class="col-md-3" [hidden]="selectPeriodicType != 'Date Range'">
                <div class="form-group">
                  <label class="control-label" for="fromDate">Start Date</label>
                  <input type="date" id="fromDate" [(ngModel)]="startDate" (change)="dateChangeFd(startDate)"
                         [ngModelOptions]="{standalone: true}"
                         class="form-control " value="1">
                </div>
                <div id="startDateError" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!startDateError">{{startDateError}}</div>
              </div>
              <div class="col-md-3" [hidden]="selectPeriodicType != 'Date Range'">
                <div class="form-group">
                  <label class="control-label" for="toDate">End Date</label>
                  <input type="date" id="toDate" [(ngModel)]="endDate" [ngModelOptions]="{standalone: true}"
                         class="form-control" value="1">
                </div>
                <div id="endDateError" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!endDateError">{{endDateError}}</div>
              </div>
              <div class="col-md-3" [hidden]="selectPeriodicType != 'Last Days'">
                <div class="form-group">
                  <label class="control-label" for="noOfDays">Select</label>
                  <div class="form-group">
                    <input type="text" id="noOfDays" appOnlyNumbers [(ngModel)]="noOfDays"
                           [ngModelOptions]="{standalone: true}" class="form-control">
                  </div>
                  <div id="noOfDaysError" class="invalid-feedback d-block shift-invalid-login"
                       [hidden]="!noOfDaysError">{{noOfDaysError}}</div>
                </div>
              </div>
              <div class="col-md-3" [hidden]="selectPeriodicType != 'Order Number'">
                <div class="form-group">
                  <label class="control-label" for="sourceOrderNumber">Source Order Number</label>
                  <div class="form-group">
                    <input type="text" id="sourceOrderNumber" appOnlyNumbers [(ngModel)]="sourceOrderNumber"
                           [ngModelOptions]="{standalone: true}" class="form-control">
                  </div>
                  <div id="sourceOrderNoError" class="invalid-feedback d-block shift-invalid-login"
                       [hidden]="!sourceOrderNoError">{{sourceOrderNoError}}</div>
                </div>
              </div>
              <div class="col-md-3">
                <button class="btn btn-cancel-prime mt-0 mt-md-4" *ngIf="selectPeriodicType !== 'Order Number'" >Sync Order(s)</button>
                <button class="btn btn-cancel-prime mt-0 mt-md-4" *ngIf="selectPeriodicType === 'Order Number'" >Sync Order(s)</button>
              </div>
            </div>
          </div>

          <div [hidden]="!(tabActive =='updateOrders' && updateOrders)">

            <div class="row-box " >
              <div class="row border-bottom">
                <div class="col-md-3"><b>Shift Status</b></div>
                <div class="col-md-5">
                  <b>Provider Status</b>
                </div>
              </div>
              <div class="row border-bottom align-items-center" *ngFor="let c of orderStatuses;let i = index;">
                <div class="col-md-3">
                  {{(c.config == 'SUBMITTED' ? 'New' :
                  (c.config == 'IN_PROCESS' ? 'In process' :
                  (c.config == 'READY_TO_SHIP' ? 'Ready to ship' :
                  (c.config == 'DELIVERED' ? 'Delivered' :
                  (c.config == 'INVOICED' ? 'Invoice' :
                  (c.config == 'EXCEPTION' ? 'Exception' :
                  (c.config == 'CANCELLED' ? 'Cancelled' :
                  (c.config == 'ON_HOLD' ? 'On Hold' :c.config))))))))}}
                </div>
                <div class="col-md-4">
                  <select id="addressType" class="form-control" [(ngModel)]="selectedOrderStatus[i]"
                          [ngModelOptions]="{standalone: true}" (change)="submitStatus(c.config,selectedOrderStatus[i])" required>
                    <option *ngFor="let p of providerStatuses" [ngValue]="p.config">
                      {{p.config}}</option>
                    <option value=""> </option>
                  </select>
                </div>
              </div>


            </div>

            <!--<button type="submit" class="btn btn-orange">Save</button>-->
          </div>

          <div [hidden]="!(tabActive =='scheduleOrders' && scheduleOrders)">
            <div class="row mb-3 align-items-center">

              <div class="col-md-6"><div class="form-radio mr-4">
                <input type="radio" id="periodically" [(ngModel)]="store.syncType"
                       [ngModelOptions]="{standalone: true}" required value="PERIODICALLY">
                <label for="periodically" >PERIODICALLY</label>
              </div> <!--<div class="form-radio">
                <input type="radio" id="specificDays" [(ngModel)]="store.syncType"
                       [ngModelOptions]="{standalone: true}" required value="SPECIFICDAYS">
                <label for="specificDays">Specific Days</label>
              </div>-->
              </div>
            </div>

            <!-- Periodically -->
            <div class="row"  [hidden]="store.syncType != 'PERIODICALLY'">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label" for="startDate">Start Date</label>
                  <input type="date" id="startDate" [(ngModel)]="store.startDate" (change)="dateChangeSd(store.startDate)"
                         [ngModelOptions]="{standalone: true}" class="form-control" value="1">
                </div>
                <div id="statusText30" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!statusText30">{{statusText30}}</div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label" for="endDate">End Date</label>
                  <input type="date" id="endDate" [(ngModel)]="store.endDate"
                         [ngModelOptions]="{standalone: true}" class="form-control" value="1">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label" for="durationType">Duration Type</label>
                  <select class="form-control" id="durationType"
                          [(ngModel)]="store.durationType"
                          [ngModelOptions]="{standalone: true}" required>
                    <option value="minute">Minute(s)</option>
                    <option value="hour">Hour(s)</option>
                    <option value="day">Day(s)</option>
                    <option value="week">Week(s)</option>
                    <option value="month">Month(s)</option>
                  </select>
                </div>
                <div id="statusText33" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!statusText33">{{statusText33}}</div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label" for="syncDuration">Frequency</label>
                  <input type="text" id="syncDuration" maxlength="2" [(ngModel)]="store.duration"
                         [ngModelOptions]="{standalone: true}" class="form-control" value="1">
                </div>
                <div id="statusText32" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!statusText32">{{statusText32}}</div>
              </div>

            </div>
            <!-- End Periodically -->


            <!-- Specific Days -->
            <div class="row" [hidden]="store.syncType != 'SPECIFICDAYS'">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label" for="spstartDate">Start Date</label>
                  <input type="date" id="spstartDate" [(ngModel)]="store.sstartDate" (change)="dateChangeSp(store.sstartDate)"
                         [ngModelOptions]="{standalone: true}" class="form-control" value="1">
                </div>
                <div id="statusText34" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!statusText34">{{statusText34}}</div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label" for="spendDate">End Date</label>
                  <input type="date" id="spendDate" [(ngModel)]="store.eendDate"
                         [ngModelOptions]="{standalone: true}" class="form-control" value="1">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label">Date of Every Month</label>
                  <ul class="days">
                    <li>1</li>
                    <li>2</li>
                    <li>3</li>
                    <li>4</li>
                    <li>5</li>
                    <li>6</li>
                    <li>7</li>
                    <li>8</li>
                    <li>9</li>
                    <!--
                                          <li><span class="active">10</span></li>
                    -->
                    <li>10</li>
                    <li>11</li>
                    <li>12</li>
                    <li>13</li>
                    <li>14</li>
                    <li>15</li>
                    <li>16</li>
                    <li>17</li>
                    <li>18</li>
                    <li>19</li>
                    <li>20</li>
                    <li>21</li>
                    <li>22</li>
                    <li>23</li>
                    <li>24</li>
                    <li>25</li>
                    <li>26</li>
                    <li>27</li>
                    <li>28</li>
                    <li>29</li>
                    <li>30</li>
                    <li>31</li>
                  </ul>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label">Date of Every Week</label>
                  <ul class="days">
                    <li>SUN</li>
                    <li>MON</li>
                    <li>TUE</li>
                    <li>WED</li>
                    <li>THU</li>
                    <li>FRI</li>
                    <li>SAT</li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- End Specific Days -->



            <button type="submit" class="btn btn-orange mt-2 mb-2" (click)="syncProcess()">Save</button>
            <div class="row-box">
              <div class="table-3">
                <table class="table packing-table mb-0">
                  <thead class="thead-light">
                  <tr><th>Schedule Type</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Frequency</th>
                    <th>Actions</th>
                  </tr></thead>
                  <tbody>
                  <tr *ngFor="let s of scheduleStores;let i = index;">
                    <td>{{s.syncType}}</td>
                    <td>{{s.startDate}}</td>
                    <td>{{s.endDate}}</td>
                    <td>{{(s.duration +' '+ s.durationType +'(s)' | titlecase)}}</td>
                    <td [hidden]="s.length == 0">
                    <!--  <a data-toggle="modal" data-target="#editApiPop" (click)="editPopup(i)"
                      class="p-2 ml-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20.25 20.25">
                          <g id="pencil-black-tool-interface-symbol" transform="translate(-0.002)">
                            <g id="Group_1" data-name="Group 1" transform="translate(0.002)">
                              <path fill="#8A55BB" id="Path_1" data-name="Path 1" d="M0,483.655l2.127-.277L.279,481.528Z" transform="translate(-0.002 -463.405)"/>
                              <path fill="#8A55BB" id="Path_2" data-name="Path 2" d="M10.875,109.069l-.218,1.672,2.572,2.572,1.672-.218,11.381-11.381-4.026-4.026Z" transform="translate(-10.272 -93.448)"/>
                              <path fill="#8A55BB" id="Path_3" data-name="Path 3" d="M350.694.2A.7.7,0,0,0,350.2,0a.753.753,0,0,0-.532.223L346.92,2.97,350.946,7l2.747-2.747a.726.726,0,0,0,.02-1.026Z" transform="translate(-333.666)"/>
                            </g>
                          </g>
                        </svg>
                      </a>-->
                      <a data-toggle="modal" data-target="#deleteApiPop" (click)="removeStore(i)"
                                                    class="p-2 ml-3">
                        <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" height="21" viewBox="0 0 18.877 24.27">
                          <defs><style>.a{fill:#848484;}</style></defs>
                          <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
                        </svg></a></td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr><td colspan="5"></td>
                  </tr></tfoot>
                </table></div>
            </div>
          </div>

        </div>
      </div>
      <div class="inner-box pb-0 pt-4 h-auto" [hidden]="tabClicked != 'PRODUCTS'">
        <div class="row">
          <div class="col-11">
            <div class="row no-gutters">
              <!--<div class="col-md-3">
                <div id="importProducts" class="grid-box active">
                  <div class="row align-items-center justify-content-between">
                    <div class="col-auto">
                      <h2 class="color-3 text-capitalize">Import Products</h2>
                    </div>
                    <div class="col-auto"><div class="toggle-2">
                      <input type="checkbox" id="importProductsCB" name="import" [(ngModel)]="importProducts" checked="" class="custom-control-input checkbox">
                      <label for="importProductsCB" class="toggle">
                        <span>ON</span><span>OFF</span>
                      </label>
                    </div> </div>
                  </div>
                  <div class="c-height">
                    Please mention order statuses from your channel that you want to pull into the Processing state in Shift
                  </div>
                  <button class="btn btn-cancel-prime" [disabled]="!importProducts" (click)="openDetailSection('importProducts')">Manage</button>
                </div>
              </div>-->
             <!-- <div class="col-md-3">
                <div id="scheduleProducts" class="grid-box" [ngClass]="{'active':tabActive !== 'manualImportProducts'}">
                  <div class="row align-items-center justify-content-between">
                    <div class="col-auto">
                      <h2 class="color-3 text-capitalize">Schedule Products Sync</h2>
                    </div>
                    <div class="col-auto"><div class="toggle-2">
                      <input type="checkbox" id="scheduleProductsCB" name="Schedule" [(ngModel)]="scheduleProducts" checked="" class="custom-control-input checkbox" >
                      <label for="scheduleProductsCB" class="toggle">
                        <span>ON</span><span>OFF</span>
                      </label>
                    </div> </div>
                  </div>
                  <div class="c-height">
                    Please mention order statuses from your channel that you want to pull into the Processing state in Shift
                  </div>
                  <button class="btn btn-cancel-prime" [disabled]="!scheduleProducts" (click)="openDetailSection('scheduleProducts')">Manage</button>
                </div>
              </div>-->
              <div class="col-md-3">
                <div id="manualImportProducts" class="grid-box" [ngClass]="{'active':tabActive == 'manualImportProducts'}">
                  <div class="row align-items-center justify-content-between">
                    <div class="col-auto">
                      <h2 class="color-3 text-capitalize">Manual Import</h2>
                    </div>
                    <div class="col-auto"><div class="toggle-2">
                      <input type="checkbox" id="manualImportsProducts" name="Manual" checked="" [(ngModel)]="manualImportsProducts" class="custom-control-input checkbox" (change)="submitAll()">
                      <label for="manualImportsProducts" class="toggle">
                        <span>ON</span><span>OFF</span>
                      </label>
                    </div> </div>
                  </div>
                  <div class="c-height">
                    Please mention order statuses from your channel that you want to pull into the Processing state in Shift
                    You can import products into Shift with below options form your channel
                  </div>
                  <button class="btn btn-cancel-prime" [disabled]="!manualImportsProducts" (click)="openDetailSection('manualImportProducts')">Manage</button>
                </div>
              </div>

            </div>
          </div>
        </div>
        <div class="grid-main">
          <!-- Import Orders -->
          <div *ngIf="tabActive =='importProducts' && importProducts">
            <div class="row" >
              <div class="col-md-5">
                <div class="form-group">
                  <label class="control-label">Status to fetch</label>
                  <ng-multiselect-dropdown
                    [placeholder]="'Select status'"
                    [data]="dropdownList"
                    [(ngModel)]="selectedItems"
                    [settings]="dropdownSettings"
                    (onSelect)="submitAll()"
                    (onSelectAll)="submitAll()"
                    (onDeSelectAll)="submitAll()"
                    (onDeSelect)="submitAll()"
                  >
                  </ng-multiselect-dropdown>
                </div>
              </div>
            </div>
            <!--<button type="submit" class="btn btn-orange">Save</button>-->
          </div>

          <!-- End Import Orders -->

          <!-- Manual -->
          <div  [hidden]="!(tabActive =='manualImportProducts' && manualImportsProducts)">
            <div class="row">
              <div class="col-md-6"><div class="form-radio mr-4">
                <input type="radio" (change)="selectDateTypeProducts()" name="periodicTypeProducts" id="dateRangeProducts"
                       [(ngModel)]="selectPeriodicTypeProducts" [ngModelOptions]="{standalone: true}" required
                       value="Date Ranges">
                <label for="dateRangeProducts">Date Range</label>
              </div> <div class="form-radio">
                <input type="radio" (change)="selectDateTypeProducts()" name="periodicTypeProducts" id="lastDaysProducts"
                       [(ngModel)]="selectPeriodicTypeProducts" [ngModelOptions]="{standalone: true}" required
                       value="Last Days">
                <label for="lastDaysProducts">No. of Days</label>
              </div></div>
            </div>
            <!-- Date Range -->
            <div class="row mt-3">
              <div class="col-md-3" [hidden]="selectPeriodicTypeProducts != 'Date Ranges'">
                <div class="form-group">
                  <label class="control-label" for="fromDateProducts">Start Date</label>
                  <input type="date" id="fromDateProducts" [(ngModel)]="startDateProducts" (change)="dateChangeFdp(startDateProducts)"
                         [ngModelOptions]="{standalone: true}"
                         class="form-control date" value="1">
                </div>
                <div id="startDateErrorProducts" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!startDateErrorProducts">{{startDateErrorProducts}}</div>
              </div>
              <div class="col-md-3" [hidden]="selectPeriodicTypeProducts != 'Date Ranges'">
                <div class="form-group">
                  <label class="control-label" for="toDateProducts">End Date</label>
                  <input type="date" id="toDateProducts" [(ngModel)]="endDateProducts" [ngModelOptions]="{standalone: true}"
                         class="form-control date" value="1">
                </div>
                <div id="endDateErrorProducts" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!endDateErrorProducts">{{endDateErrorProducts}}</div>
              </div>
              <div class="col-md-3" [hidden]="selectPeriodicTypeProducts != 'Last Days'">
                <div class="form-group">
                  <label class="control-label" for="noOfDaysProducts">Select</label>
                  <input type="text" id="noOfDaysProducts" appOnlyNumbers [(ngModel)]="noOfDaysProducts"
                         [ngModelOptions]="{standalone: true}" class="form-control">
                </div>
                <div id="noOfDaysErrorProducts" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!noOfDaysErrorProducts">{{noOfDaysErrorProducts}}</div>
              </div>
              <div class="col-md-3">
                <button class="btn btn-cancel-prime mt-0 mt-md-4" >Sync Products</button>
              </div>
            </div>
            <!-- End Date Range -->
            <!--<button type="submit" class="btn btn-orange">Save</button>-->
          </div>
          <!-- End Manual -->
          <!-- Schedule -->
          <div [hidden]="!(tabActive =='scheduleProducts' && scheduleProducts)">
            <div class="row mb-3 align-items-center">
              <div class="col-md-6"><div class="form-radio mr-4">
                <input type="radio" id="periodicallyProducts" [(ngModel)]="store.syncTypes"
                       [ngModelOptions]="{standalone: true}" required value="PERIODICALY">
                <label for="periodicallyProducts">PERIODICALLY</label>
              </div>
                <!--<div class="form-radio">
                <input type="radio" id="specificDaysProducts" [(ngModel)]="store.syncTypes"
                       [ngModelOptions]="{standalone: true}" required value="SPECIFICDAYS">
                <label for="specificDaysProducts">Specific Days</label>
              </div>-->
              </div>
            </div>
            <!-- Periodically -->
            <div class="row"  [hidden]="store.syncTypes != 'PERIODICALY'">
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label" for="startDateProducts">Start Date</label>
                  <input type="date" id="startDateProducts" [(ngModel)]="store.startDateProducts" (change)="dateChange(store.startDateProducts)"
                         [ngModelOptions]="{standalone: true}" class="form-control" value="1">
                </div>
                <div id="errorStartDate" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!errorStartDate">{{errorStartDate}}</div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label" for="endDateProducts">End Date</label>
                  <input type="date" id="endDateProducts" [(ngModel)]="store.endDateProducts"
                         [ngModelOptions]="{standalone: true}" class="form-control" value="1">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label" for="durationTypeProducts">Duration Type</label>
                  <select class="form-control" id="durationTypeProducts"
                          [(ngModel)]="store.durationTypeProducts"
                          [ngModelOptions]="{standalone: true}" required>
                    <option value="minute">Minute(s)</option>
                    <option value="hour">Hour(s)</option>
                    <option value="day">Day(s)</option>
                    <option value="week">Week(s)</option>
                    <option value="month">Month(s)</option>
                  </select>
              </div>
                <div id="errorDurationType" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!errorDurationType">{{errorDurationType}}</div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label" for="syncDurationProducts">Frequency</label>
                  <input type="text" id="syncDurationProducts" maxlength="2" [(ngModel)]="store.durationProducts"
                         [ngModelOptions]="{standalone: true}" class="form-control" value="1">
                </div>
                <div id="errorDuration" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!errorDuration">{{errorDuration}}</div>
              </div>
            </div>
            <!-- End Periodically -->
            <!-- Specific Days -->
            <div class="row" [hidden]="store.syncTypes != 'SPECIFICDAYS'">
              <div class="col-md-3" >
                <div class="form-group">
                  <label class="control-label" for="spstartDateProducts">Start Date</label>
                  <input type="date" id="spstartDateProducts" [(ngModel)]="store.sstartDateProducts" (change)="dateChangeSps(store.sstartDateProducts)"
                         [ngModelOptions]="{standalone: true}" class="form-control" value="1">
                </div>
                <div id="errorSStartDate" class="invalid-feedback d-block shift-invalid-login"
                     [hidden]="!errorSStartDate">{{errorSStartDate}}</div>
              </div>
              <div class="col-md-3" >
                <div class="form-group">
                  <label class="control-label" for="spendDateProducts">End Date</label>
                  <input type="date" id="spendDateProducts" [(ngModel)]="store.eendDateProducts"
                         [ngModelOptions]="{standalone: true}" class="form-control" value="1">
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label">Date of Every Month</label>
                  <ul class="days">
                    <li>1</li>
                    <li>2</li>
                    <li>3</li>
                    <li>4</li>
                    <li>5</li>
                    <li>6</li>
                    <li>7</li>
                    <li>8</li>
                    <li>9</li>
                    &lt;!&ndash;
                    <li><span class="active">10</span></li>
                    &ndash;&gt;
                    <li>10</li>
                    <li>11</li>
                    <li>12</li>
                    <li>13</li>
                    <li>14</li>
                    <li>15</li>
                    <li>16</li>
                    <li>17</li>
                    <li>18</li>
                    <li>19</li>
                    <li>20</li>
                    <li>21</li>
                    <li>22</li>
                    <li>23</li>
                    <li>24</li>
                    <li>25</li>
                    <li>26</li>
                    <li>27</li>
                    <li>28</li>
                    <li>29</li>
                    <li>30</li>
                    <li>31</li>
                  </ul>
                </div>
              </div>
              <div class="col-md-3">
                <div class="form-group">
                  <label class="control-label">Date of Every Week</label>
                  <ul class="days">
                    <li>SUN</li>
                    <li>MON</li>
                    <li>TUE</li>
                    <li>WED</li>
                    <li>THU</li>
                    <li>FRI</li>
                    <li>SAT</li>
                  </ul>
                </div>
              </div>
            </div>
            <!-- End Specific Days -->
            <button type="submit" class="btn btn-orange mt-2 mb-2" (click)="syncProductsProcess()">Save</button>
            <div class="row-box">
              <div class="table-3">
                <table class="table packing-table mb-0">
                  <thead class="thead-light">
                  <tr><th>Schedule</th>
                    <th>Start Date</th>
                    <th>End Date</th>
                    <th>Frequency</th>
                    <th>Actions</th>
                  </tr></thead>
                  <tbody>
                  <tr *ngFor="let s of scheduleStores;let i = index;">
                    <td>{{s.syncType}}</td>
                    <td>{{s.startDate}}</td>
                    <td>{{s.endDate}}</td>
                    <td>{{(s.duration +' '+ s.durationType +'(s)' | titlecase)}}</td>
                    <td [hidden]="s.length == 0">
                     <!-- <a data-toggle="modal" data-target="#editApiPop" (click)="editPopup(i)"
                         class="p-2 ml-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 20.25 20.25">
                          <g id="pencil-black-tool-interface-symbol" transform="translate(-0.002)">
                            <g id="Group_1" data-name="Group 1" transform="translate(0.002)">
                              <path fill="#8A55BB" id="Path_1" data-name="Path 1" d="M0,483.655l2.127-.277L.279,481.528Z" transform="translate(-0.002 -463.405)"/>
                              <path fill="#8A55BB" id="Path_2" data-name="Path 2" d="M10.875,109.069l-.218,1.672,2.572,2.572,1.672-.218,11.381-11.381-4.026-4.026Z" transform="translate(-10.272 -93.448)"/>
                              <path fill="#8A55BB" id="Path_3" data-name="Path 3" d="M350.694.2A.7.7,0,0,0,350.2,0a.753.753,0,0,0-.532.223L346.92,2.97,350.946,7l2.747-2.747a.726.726,0,0,0,.02-1.026Z" transform="translate(-333.666)"/>
                            </g>
                          </g>
                        </svg>
                      </a>-->
                      <a data-toggle="modal" data-target="#deleteApiPop" (click)="removeStore(i)"
                         class="p-2 ml-3">
                        <svg xmlns="http://www.w3.org/2000/svg" class="mr-2" height="21" viewBox="0 0 18.877 24.27">
                          <defs><style>.a{fill:#848484;}</style></defs>
                          <path class="a" d="M8.848,26.073a2.7,2.7,0,0,0,2.7,2.7H22.332a2.7,2.7,0,0,0,2.7-2.7V9.893H8.848Zm3.317-9.6,1.9-1.9,2.872,2.858L19.8,14.572l1.9,1.9L18.84,19.332,21.7,22.19l-1.9,1.9-2.858-2.858L14.08,24.091l-1.9-1.9,2.858-2.858ZM21.658,5.848,20.309,4.5H13.568L12.219,5.848H7.5v2.7H26.377v-2.7Z" transform="translate(-7.5 -4.5)"/>
                        </svg></a></td>
                  </tr>
                  </tbody>
                  <tfoot>
                  <tr><td colspan="5"></td>
                  </tr></tfoot>
                </table></div>
            </div>
          </div>
          <!-- End Schedule -->
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="modal fade" id="editApiPop" role="dialog">
      <div class="modal-dialog">
        &lt;!&ndash; Modal content&ndash;&gt;
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Edit</h4>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <div class="row mb-3 align-items-center">

              <div class="col-6">
                <div class="form-radio mr-4">
                <input type="radio" id="scheduleStoreperiodically" [(ngModel)]="scheduleStore.syncType"
                       [ngModelOptions]="{standalone: true}" required value="PERIODICALLY">
                <label for="scheduleStoreperiodically" >PERIODICALLY</label>
              </div>
              </div>
              <div class="col-6">
              <!--<div class="form-radio">
                <input type="radio" id="scheduleStorespecificDays" [(ngModel)]="scheduleStore.syncType"
                       [ngModelOptions]="{standalone: true}" required value="SPECIFICDAYS">
                <label for="scheduleStorespecificDays">Specific Days</label>
              </div>-->
              </div>
            </div>

            <!-- Periodically -->
            <div class="row"  [hidden]="scheduleStore.syncType != 'PERIODICALLY'">
              <div class="col">
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label class="control-label" for="scheduleStorestartDate">Start Date</label>
                      <input type="date" id="scheduleStorestartDate" [(ngModel)]="scheduleStore.startDate" (change)="dateChangeSd(scheduleStore.startDate)"
                             [ngModelOptions]="{standalone: true}" class="form-control" value="1">
                    </div>
                    <div id="statusText30" class="invalid-feedback d-block shift-invalid-login"
                         [hidden]="!statusText30">{{statusText30}}</div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label class="control-label" for="scheduleStoreendDate">End Date</label>
                      <input type="date" id="scheduleStoreendDate" [(ngModel)]="scheduleStore.endDate"
                             [ngModelOptions]="{standalone: true}" class="form-control" value="1">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label class="control-label" for="scheduleStoredurationType">Duration Type</label>
                      <select class="form-control" id="scheduleStoredurationType"
                              [(ngModel)]="scheduleStore.durationType"
                              [ngModelOptions]="{standalone: true}" required>
                        <option value="minute">Minute(s)</option>
                        <option value="hour">Hour(s)</option>
                        <option value="day">Day(s)</option>
                        <option value="week">Week(s)</option>
                        <option value="month">Month(s)</option>
                      </select>
                    </div>
                    <div id="statusText33" class="invalid-feedback d-block shift-invalid-login"
                         [hidden]="!statusText33">{{statusText33}}</div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label class="control-label" for="scheduleStoresyncDuration">Frequency</label>
                      <input type="text" id="scheduleStoresyncDuration" maxlength="2" [(ngModel)]="scheduleStore.duration"
                             [ngModelOptions]="{standalone: true}" class="form-control" value="1">
                    </div>
                    <div id="statusText32" class="invalid-feedback d-block shift-invalid-login"
                         [hidden]="!statusText32">{{statusText32}}</div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End Periodically -->


            <!-- Specific Days -->
            <div class="row"  [hidden]="scheduleStore.syncType != 'SPECIFICDAYS'">
              <div class="col">
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label class="control-label" for="scheduleStorespstartDate">Start Date</label>
                      <input type="date" id="scheduleStorespstartDate" [(ngModel)]="scheduleStore.sstartDate" (change)="dateChangeSp(scheduleStore.sstartDate)"
                             [ngModelOptions]="{standalone: true}" class="form-control" value="1">
                    </div>
                    <div id="statusText34" class="invalid-feedback d-block shift-invalid-login"
                         [hidden]="!statusText34">{{statusText34}}</div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label class="control-label" for="scheduleStorespendDate">End Date</label>
                      <input type="date" id="scheduleStorespendDate" [(ngModel)]="scheduleStore.eendDate"
                             [ngModelOptions]="{standalone: true}" class="form-control" value="1">
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-6">
                    <div class="form-group">
                      <label class="control-label">Date of Every Month</label>
                      <ul class="days">
                        <li>1</li>
                        <li>2</li>
                        <li>3</li>
                        <li>4</li>
                        <li>5</li>
                        <li>6</li>
                        <li>7</li>
                        <li>8</li>
                        <li>9</li>
                        <!--
                                              <li><span class="active">10</span></li>
                        -->
                        <li>10</li>
                        <li>11</li>
                        <li>12</li>
                        <li>13</li>
                        <li>14</li>
                        <li>15</li>
                        <li>16</li>
                        <li>17</li>
                        <li>18</li>
                        <li>19</li>
                        <li>20</li>
                        <li>21</li>
                        <li>22</li>
                        <li>23</li>
                        <li>24</li>
                        <li>25</li>
                        <li>26</li>
                        <li>27</li>
                        <li>28</li>
                        <li>29</li>
                        <li>30</li>
                        <li>31</li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label class="control-label">Date of Every Week</label>
                      <ul class="days">
                        <li>SUN</li>
                        <li>MON</li>
                        <li>TUE</li>
                        <li>WED</li>
                        <li>THU</li>
                        <li>FRI</li>
                        <li>SAT</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- End Specific Days -->

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-delete" data-dismiss="modal" (click)="closeEditPopup()">No</button>
            <button type="button" class="btn btn-edit" data-dismiss="modal" (click)="editSchedule()">Yes</button>
          </div>
        </div>
      </div>
    </div>
  </div><div class="container">

    <div class="modal fade" id="deleteApiPop" role="dialog">
      <div class="modal-dialog">
        &lt;!&ndash; Modal content&ndash;&gt;
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">Delete</h4>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
          </div>
          <div class="modal-body">
            <p>Do you really want to delete </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-delete" data-dismiss="modal" (click)="closePopup()">No</button>
            <button type="button" class="btn btn-edit" data-dismiss="modal" (click)="deleteSchedule(scheduleStores[index].id,index)">Yes</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
